var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};
(function ($) {
  'use strict';

  $(document).on('change', '.js-mpp-sort-menu', function () {
    var $selectedOption = $('option:selected', $(this));

    if (!!$selectedOption.data('shadeSelect')) {
      // Drupal.behaviors.mppSortV3.$grids.trigger('shade-selectFirst', $selectedOption.data('shadeSelect'));
    }
    Drupal.behaviors.mppSortV3.$grids.trigger('mpp-sortBy', $selectedOption.attr('value'));
  });
  $(document).on('review-snippet-loaded', '.js-product-ui', function (e, eventData) {
    var $product = $(this);

    Drupal.behaviors.mppSortV3.setRatingData($product, eventData);
  });

  Drupal.behaviors.mppSortV3 = {
    $grids: $(),
    isMobile: false,
    isMedium: false,
    dropDownWidth: 0,
    selector: {
      container: '.js-mpp-custom-override-layout',
      grid: '.js-product-grid--sortable',
      item: '.js-product-grid-item',
      sort: '.js-mpp-sort__container--v3',
      filtersContainer: '.js-filters_container--inner',
      sortContainer: '.js-mpp-sort-wrapper'
    },

    hideOption: {
      'data-sort-new': true,
      'data-sort-bestseller': true
    },

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.isMobile = self.checkIfMobile();
      self.isMedium = self.checkIfMedium();
      self.$grids = $(self.selector.grid, context);
      self.$grids.each(function () {
        var $this = $(this);

        self.getDom($this);
        self.setup($this);
      });
    },

    checkIfMobile: function () {
      if (!!Unison.fetch.now()) {
        var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

        return currentBpWidth <= bPlargeUp;
      }

      return false;
    },

    checkIfMedium: function () {
      if (!!Unison.fetch.now()) {
        var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        var bPlargeUp = parseInt(Unison.fetch.all()['usn-large'], 10);

        return currentBpWidth <= bPlargeUp;
      }

      return false;
    },

    setRatingData: function ($product, ratingData) {
      var self = this;
      // parsing for element here since this function is independent from the rest of the behavior
      // and only triggers once
      var $gridItem = $product.closest(self.selector.item);
      var avgRating = ratingData.result.rollup.average_rating;
      var sortRating = (avgRating / 5) * 100;

      if (sortRating !== $gridItem.data('sortRating')) {
        $gridItem.attr('data-sort-rating', sortRating).data('sortRating', sortRating);
        $gridItem.trigger('pr-data:updated');
      }
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$container = $that.closest(self.selector.container);
      $that.nodes.$sort = $that.nodes.$container.parent().find(self.selector.sort);
      $that.nodes.$sortSelect = $that.nodes.$sort.find('select');
      $that.nodes.$items = $(self.selector.item, $that);
      $that.nodes.$sortContainer = $(self.selector.sortContainer, $that.nodes.$container);
      $that.nodes.$filtersContainer = $(self.selector.filtersContainer, $that.nodes.$container);
    },

    setup: function ($that) {
      var self = this;

      Unison.on('change', function () {
        self.isMobile = self.checkIfMobile();
        self.isMedium = self.checkIfMedium();
        self.swapLayout($that);
      });
      self.prepareSort($that);
      self.initAttributes($that);
      // move sort inside the Filters container if available
      if ($that.nodes.$filtersContainer.length > 0) {
        $that.nodes.$sortContainer.append($that.nodes.$sort);
        $that.nodes.$filtersContainer.addClass('has-sorting');
      }
      self.hideOptions($that);
      self.customizeSelect($that);
      $that.nodes.$sort.removeClass('hidden');
      self.dropDownWidth = $that.nodes.$items
        .filter(':visible')
        .find('.js-product-brief')
        .first()
        .width();
    },

    prepareSort: function ($that) {
      $that.nodes.$sortSelect.once('prepare-html', function () {
        var defaultValue = $(this).data('defaultSort');

        if (!!defaultValue) {
          if ($that.nodes.$sort.find('option[value="' + defaultValue + '"]').length > 1) {
            $that.nodes.$sort
              .find('option[value="' + defaultValue + '"]')
              .last()
              .remove();
          }
        }
      });
    },

    hideOptions: function ($that) {
      var self = this;

      $that.nodes.$sort.find('select option').each(function () {
        var $this = $(this);
        var sortStr = $this.val().split(':');
        var sortValue = sortStr[0];

        if (!!self.hideOption[sortValue]) {
          $this.remove();
        }
      });
    },

    customizeSelect: function ($that) {
      var self = this;
      var $select = $that.nodes.$sort.find('select');

      if ($select.data('select2')) {
        // on PC the select2 is auto loaded, we need to have controll over the css class
        $select.select2('destroy');
        // need to remove the listeners set by select2, doesn't do it on destroy
        $select.off('focus select2-close select2-open select2-opening');
      }
      if (self.isMobile || self.isMedium) {
        return;
      }
      // localized function from mac_base.js for mobile customization
      var dropdownCss = Drupal.settings.globals_variables.cr21_mpp ? {} : { width: self.dropDownWidth };

      $select.select2({
        adaptDropdownCssClass: function (c) {
          if (c.indexOf('js-mpp-sort-menu') === 0) {
            return 'mpp-sort-menu--v3 js-mpp-sort-menu--v3';
          }
        },
        dropdownCss: dropdownCss,
        minimumResultsForSearch: -1
      });
      if (!!$that.nodes.$sort.data('openedLabel')) {
        $that.nodes.$sort.find('.select2-chosen').html($that.nodes.$sort.data('openedLabel'));
      }
      $select.on('select2-close', function () {
        var $selectedOption = $('option:selected', $(this));

        if ($selectedOption.length > 0) {
          $that.nodes.$sort.find('.select2-chosen').html($selectedOption[0].label);
        }
      });

      $select.on('select2-opening', function () {
        $('option:selected', $(this)).addClass('select2-result-active');
        if (!!$that.nodes.$sort.data('openedLabel')) {
          $that.nodes.$sort.find('.select2-chosen').html($that.nodes.$sort.data('openedLabel'));
        }

        if (Drupal.settings.globals_variables.cr21_mpp) {
          return;
        }

        $that.nodes.$sort.once('dropdown-match-width', function () {
          var $select2Container = $that.nodes.$sort.find('.select2-container');
          var selectWidth = $select2Container.width() + 2;
          // we add 2 px for borders
          var difference = self.dropDownWidth - selectWidth;
          var adaptedLeft =
            !self.isMobile && !self.isMedium
              ? $select2Container.offset().left - difference
              : $select2Container.offset().left;

          $select.data('select2').opts.dropdownCss.left = adaptedLeft;
          $select.data('select2').opts.dropdownCss.width = self.dropDownWidth;
        });
      });
      $select.on('select2-selecting', function () {
        $('option', $(this)).removeClass('select2-result-active');
      });
      $select.on('select2-select', function () {
        $('option:selected', $(this)).addClass('select2-result-active');
      });
    },

    swapLayout: function ($that) {
      var self = this;

      self.dropDownWidth = $that.nodes.$items
        .filter(':visible')
        .find('.js-product-brief')
        .first()
        .width();
      $that.nodes.$sort.removeClass('dropdown-match-width-processed');
      self.customizeSelect($that);
    },

    initAttributes: function ($that) {
      var self = this;
      var badges = [];

      $that.nodes.$items.each(function () {
        var $item = $(this);

        badges = self.getBadgeValue($item);
        badges.forEach(function (badge) {
          self.setSortByBadge($that, $item, badge);
        });
      });
    },

    setSortByBadge: function ($that, $item, badge) {
      var self = this;
      var isNew = 0;
      var isBestseller = 0;
      var updated = false;

      if (!!badge) {
        if ($item.data('sortNew') < 1) {
          isNew = self.isValidValue(badge, 'new');
          $item.data('sortNew', isNew).attr('data-sort-new', isNew);
          updated = true;
          if (isNew === 1) {
            self.hideOption['data-sort-new'] = false;
          }
        } else {
          self.hideOption['data-sort-new'] = false;
        }
        if ($item.data('sortBestseller') < 1) {
          isBestseller = self.isValidValue(badge, 'best_seller');
          $item.data('sortBestseller', isBestseller).attr('data-sort-bestseller', isBestseller);
          updated = true;
          if (isBestseller === 1) {
            self.hideOption['data-sort-bestseller'] = false;
          }
        } else {
          self.hideOption['data-sort-bestseller'] = false;
        }
        if ($that.data('isotope') && updated === true) {
          $that.isotope('updateSortData', $item);
        }
      }
    },

    isValidValue: function (value, compareValue) {
      return value.toLowerCase() === compareValue ? 1 : 0;
    },

    getBadgeValue: function ($item) {
      var self = this;
      var badge = [];
      var productData = prodcat.data.getProduct($item.data('productId'));

      if (!!productData) {
        if (!!productData.MISC_FLAG_TEXT) {
          badge.push(self.getBadgeString(productData.MISC_FLAG_TEXT));
        }
        // uncomment if they want to use sku badges on sort
        // productData.skus.forEach(function(skuData) {
        //   if (!!skuData.MISC_FLAG_TEXT) {
        //     badge.push(self.getBadgeString(skuData.MISC_FLAG_TEXT));
        //   }
        // });
      }
      badge = _.uniq(badge);

      return badge;
    },

    getBadgeString: function (badge) {
      if (!!badge) {
        return badge.toString().trim().replace(/ /g, '_').toLowerCase();
      }

      return '';
    },

    attached: false
  };
})(jQuery);
